import React from 'react';
import { Link } from 'react-router-dom';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
    FlexDiv,
    Heading1,
    SpaceBetweenDiv,
    TextDefault,
    TextLead,
    ThemedButton,
    palette,
} from '@awarego-ui/components';
import { STATUS } from '../../../utils/constants';

const useStyles = makeStyles(() => ({
    paper: {
        minWidth: 672,
        padding: 24,
    },
    list: {
        margin: '16px 0 0',
        paddingLeft: 20,
        maxHeight: 280,
        overflowY: 'auto',
    },
}));

function trainingPath(training) {
    if (training.active === STATUS.DRAFT) {
        return `/trainings/edit/${training.id}`;
    }
    return `/trainings/${training.id}/view`;
}

function ArchiveContentDialog({
    open,
    trainings,
    archiving,
    onClose,
    onArchive,
}) {
    const classes = useStyles();
    if (!open) return null;

    return (
        <Dialog
            open
            onClose={archiving ? undefined : onClose}
            classes={{ paper: classes.paper }}
        >
            <DialogTitle>
                <SpaceBetweenDiv>
                    <Heading1>This content is used in trainings</Heading1>
                </SpaceBetweenDiv>
            </DialogTitle>
            <DialogContent>
                <TextLead>
                    Deleting it would remove the lesson from those trainings.
                    Archive keeps it in the trainings that already use it, and
                    hides it from the content library and the lesson catalog.
                </TextLead>
                <ul className={classes.list}>
                    {(trainings || []).map((training) => (
                        <li key={training.id}>
                            <Link
                                to={trainingPath(training)}
                                target="_blank"
                                rel="noreferrer"
                                style={{ color: palette.evergreen.aspargus }}
                            >
                                <TextDefault bold>
                                    {training.name}
                                </TextDefault>
                            </Link>
                        </li>
                    ))}
                </ul>
            </DialogContent>
            <DialogActions>
                <FlexDiv pr={40}>
                    <TextDefault
                        uppercase
                        extraBold
                        link
                        onClick={archiving ? undefined : onClose}
                    >
                        Cancel
                    </TextDefault>
                </FlexDiv>
                <ThemedButton
                    mode="primary"
                    text={archiving ? 'Archiving…' : 'Archive'}
                    onClick={onArchive}
                    disabled={archiving}
                />
            </DialogActions>
        </Dialog>
    );
}

export default ArchiveContentDialog;
